import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Closeable, { CloseEventListener } from '@philips-emr/tws-core/lib/component/types/closeable';
import Openable, { OpenEventListener } from '@philips-emr/tws-core/lib/component/types/openable';

class HamburgerMenuAPI extends ComponentAPI implements Closeable, Openable {
  /** @event */
  @AwesomeEvent
  onClose = new CloseEventListener();

  /** @event */
  @AwesomeEvent
  onBeforeClose = new CloseEventListener();

  /** @event */
  @AwesomeEvent
  onOpen = new OpenEventListener();

  close(): void {
    if (!this.isOpen()) {
      return;
    }
    let close = true;

    const abortFn = (): void => { close = false; };
    this.onBeforeClose.fire({ abort: abortFn });

    if (close) {
      this.setState({ open: false });
      this.onClose.fire();
    }
  }

  open(): void {
    if (this.isOpen()) {
      return;
    }

    this.setState({ open: true });
    this.onOpen.fire();
  }

  isOpen(): boolean {
    return this.state.open;
  }

  setData(data: object[]): void {
    this.setState({ data });
  }

  getData(): object[] {
    return this.state.data;
  }

  getTopOffset(): number {
    return this.state.topOffset;
  }

  setTopOffset(topOffset: number): void {
    this.setState({ topOffset });
  }
}

export default HamburgerMenuAPI;
